import { render, staticRenderFns } from "./Inventarios.vue?vue&type=template&id=6fea8857&scoped=true"
import script from "./Inventarios.vue?vue&type=script&lang=js"
export * from "./Inventarios.vue?vue&type=script&lang=js"
import style0 from "./Inventarios.vue?vue&type=style&index=0&id=6fea8857&prod&lang=scss"
import style1 from "./Inventarios.vue?vue&type=style&index=1&id=6fea8857&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea8857",
  null
  
)

export default component.exports